'use client';

import { AnimatePresence } from 'motion/react';
import * as m from 'motion/react-m';
import { FC, PropsWithChildren } from 'react';

import { LazyMotionWrapper } from 'src/general/components/LazyMotionWrapper/LazyMotionWrapper';

import { DELAY, useFormStepTransition } from './FormStepTransition.context';

const TRANSLATION_DISTANCE = 120;

const variants = {
  enter: (reverse: boolean) => {
    return {
      y: reverse ? -TRANSLATION_DISTANCE : TRANSLATION_DISTANCE,
      opacity: 0,
    };
  },
  center: {
    zIndex: 1,
    y: 0,
    opacity: 1,
  },
  exit: (reverse: boolean) => {
    return {
      zIndex: 0,
      y: reverse ? TRANSLATION_DISTANCE : -TRANSLATION_DISTANCE,
      opacity: 0,
    };
  },
};

export const FormStepTransition: FC<PropsWithChildren> = ({ children }) => {
  const { pending, pathname, reverse } = useFormStepTransition();
  return (
    <LazyMotionWrapper>
      <AnimatePresence initial={false} mode="wait" custom={reverse}>
        {!pending && (
          <m.div
            key={`${pathname}${reverse ? '-reverse' : ''}`}
            custom={reverse}
            variants={variants}
            initial="enter"
            animate="center"
            exit="exit"
            transition={{ ease: 'easeInOut', duration: DELAY / 1000 }}
          >
            {children}
          </m.div>
        )}
      </AnimatePresence>
    </LazyMotionWrapper>
  );
};
